import React from 'react';
import { Link } from '@zola/zola-ui';
import OtherThingsToReview from './OtherThingsToReview';

function TipEnclosure() {
  return (
    <div className="etiquette-tip-modal">
      <div className="tip-content-container">
        <div className="modal-body">
          <h3>Ways To Use Enclosure Cards</h3>
          <div className="section">
            <p className="desc">
              An enclosure card can serve many different purposes. Since your goal is to communicate
              the most important wedding details to your guests, this card can be used however you
              choose to share a variety of messages. Here is a list of possible types of enclosure
              cards:
            </p>
          </div>
          <div className="section">
            {/* <p className="head">1. Description of Courses (Or List Of Served Options)</p> */}
            <ul className="desc">
              <li>
                <strong>Directions Card:</strong> Provide directions to your ceremony and/or
                reception venue(s).
              </li>
              <li>
                <strong>Attire Card:</strong> List the dress code for the important wedding events.
              </li>
              <li>
                <strong>Wedding Website Card:</strong> Provide a link to your wedding website and
                list what info it contains.
              </li>
              <li>
                <strong>Accommodations Card:</strong> List hotel recommendations and reservation
                details for out-of-town guests.
              </li>
              <li>
                <strong>Transportation Card:</strong> Include info for any transportation provided
                throughout the weekend.
              </li>
              <li>
                <strong>Reception Card:</strong> Share details about a post-ceremony reception,
                including location, start time, and attire.
              </li>
              <li>
                <strong>Itinerary Card:</strong> Create an easy-to-follow itinerary for all weekend
                events.{' '}
              </li>
              <li>
                <strong>At Home Card:</strong> Let guests know your newlywed address and when you’ll
                be “at home” there following the wedding.{' '}
              </li>
              <li>
                <strong>Rehearsal Dinner Card:</strong> Share information about the rehearsal
                dinner, including location, start time, and attire.{' '}
              </li>
              <li>
                <strong>Inclement Weather Card:</strong> Share the rain plan when it includes a
                change of time or venue.
              </li>
              <li>
                <strong>Pew Assignment Card:</strong> Alert guests that they should sit in a
                “reserved” pew at the ceremony.
              </li>
              <li>
                <strong>Details Card:</strong> A catch-all card, include just a few of the above
                details on one helpful card.
              </li>
            </ul>
          </div>
          <div className="section">
            <p className="desc">
              For wording examples and more ideas for how to use enclosure cards, visit our{' '}
              <Link
                inline
                href="/expert-advice/invites-paper/wedding-invitations/a-guide-to-invitation-enclosure-cards"
                target="_blank"
                rel="noopener noreferrer"
              >
                Guide To Invitation Enclosure Cards
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
      <OtherThingsToReview />
    </div>
  );
}

export default TipEnclosure;



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/TipsModals/TipEnclosure.jsx